import i18n from 'i18n'
import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: '1 adult', value: 1 },
    { label: '2 adults', value: 2 },
    { label: '3 adults', value: 3 },
    { label: '4 adults', value: 4 },
    { label: '5 adults', value: 5 },
    { label: '6 adults', value: 6 },
    { label: '7 adults', value: 7 },
    { label: '8 adults', value: 8 },
    { label: '9 adults', value: 9 },
    { label: '10 adults', value: 10 },
]

export default function SelectOccupationAdults({...props}) {
    const myProps = {
        placeholder: i18n.t('common:filters.adultOccupation'),
        formatOptionLabel: opt => i18n.t('common:units.adults', { count: Number(opt?.value) }),
        firstSelect: true,
        options: OPTIONS,
        icon: { icon: 'user' },
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}